import { SectionTitleProps } from "../../types";

export default function SectionTitle({
  tag,
  title,
  sub,
  light = false,
}: SectionTitleProps) {
  return (
    <div style={{ textAlign: "center", marginBottom: 56 }}>
      <span
        style={{
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: 2,
          textTransform: "uppercase",
          padding: "8px 16px",
          borderRadius: 50,
          display: "inline-block",
          color: light ? "#99f6e4" : "#0d9488",
          background: light ? "rgba(255,255,255,0.1)" : "#f0fdfa",
        }}
      >
        {tag}
      </span>
      <h2
        style={{
          fontSize: "clamp(28px,4vw,36px)",
          fontWeight: 700,
          marginTop: 16,
          marginBottom: 12,
          color: light ? "white" : "#1e293b",
        }}
      >
        {title}
      </h2>
      {sub && (
        <p
          style={{
            maxWidth: 420,
            margin: "0 auto",
            fontSize: 16,
            color: light ? "#bfdbfe" : "#64748b",
            lineHeight: 1.6,
          }}
        >
          {sub}
        </p>
      )}
    </div>
  );
}
